import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import { returnAllDrugs, returnAllEquipments } from "../../../../api/area";
import medicine from "../../../../assets/image/medicine-prescription.png";

export default function ReturnAllDrugsPop({
  open,
  setOpen,
  areaId,
  equipment,
}) {
  const handleClose = () => {
    // setShow(false);
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      //   sx={{}}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          height: 350,
          bgcolor: "white",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box display="grid" justifyItems={"center"}>
          <img src={medicine} />
          <Typography fontSize="20px" fontWeight={"bold"}>
            {equipment ? "بازگشت به تجهیزات" : "بازگشت به داروخانه"}
          </Typography>
          <Typography mt="10px">
            {equipment
              ? "با کلیک کردن تایید تمام تجهیزات به انبار تجهیزات مرکزی منتقل میشود."
              : "با کلیک کردن تایید تمام داروها به انبار داروخانه مرکزی منتقل میشود."}
          </Typography>
          <Box
            bgcolor="var(--emr-darkblue)"
            color={"white"}
            textAlign={"center"}
            width="350px"
            p="10px"
            borderRadius={"11px"}
            mt="20px"
            sx={{ cursor: "pointer" }}
            onClick={() => {
              if (equipment) {
                returnAllEquipments(areaId)
                  .then((x) => setOpen(false))
                  .catch(() => {});
              } else {
                returnAllDrugs(areaId)
                  .then((x) => setOpen(false))
                  .catch(() => {});
              }
            }}
          >
            {"تایید"}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
